import { type ApplicationModes } from '../../constants/application-modes';

export const onKeyboardPress: (
	pressType: string,
	title: string,
	applicationMode: ApplicationModes,
) => {
	type: string;
	data: {
		actionSubject: string;
		action: string;
		source: string;
		attributes: {
			pressType: string;
			title: string;
			mode: ApplicationModes;
		};
	};
} = (pressType: string, title: string, applicationMode: ApplicationModes) => {
	return {
		type: 'sendUIEvent',
		data: {
			actionSubject: 'keyboard',
			action: 'pressed',
			source: 'fullPageSearch',
			attributes: {
				pressType,
				title,
				mode: applicationMode,
			},
		},
	};
};
